import React from "react";
import { Box } from "@mui/material";
import toggleButtonStyle from "./toggleButtonStyle";
import PropTypes from "prop-types";


// ToggleButton component to switch between xeokit and VC views
const ToggleButton = ({ activeView, onToggle})   => {
    const classes = toggleButtonStyle();

    return (
        <Box className={classes.toggleContainer}>

            <Box
                className={`${classes.switcher} ${activeView === "IFC" ? classes.switcherLeft : classes.switcherRight
            }`} />

            {/* Toggle Option for IFC View */}
            <Box
              className={`${classes.toggleOption} ${activeView === "IFC" ? classes.activeText : ""
              }`}
              onClick={() => onToggle("IFC")}
             >
             BIM
            </Box>

            {/* Toggle Option for City View */}
            <Box
              className={`${classes.toggleOption} ${activeView === "City" ? classes.activeText : ""
              }`}
              onClick={() => onToggle("City")}
             >
              City
            </Box>

        </Box>
    );
};

// PropTypes for type checking
ToggleButton.propTypes = {
    activeView: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default ToggleButton;